'use client';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { promotionClicked } from '@repo/ui/src/services/analytics';
import { LinkProps } from '@repo/ui/src/types';
import React from 'react';

export interface CountdownClockProps {
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
}

export interface SitewidePromotionProps {
  link: LinkProps;
  text: string;
  countdownClock?: CountdownClockProps;
  promotionId: string;
  isDefault: boolean | null;
  rotationTime: 'long' | 'standard';
}

interface Props extends SitewidePromotionProps {
  index?: number;
  CountDownClock?: React.ComponentType<CountdownClockProps>;
}

const SitewidePromotion = ({ link, text, promotionId, countdownClock, index, CountDownClock }: Props) => (
  <li
    className={`slider-${index} tw-inline-flex tw-items-center tw-flex-row tw-flex-wrap tw-absolute tw-opacity-0 first:tw-relative first:tw-opacity-100 tw-text-warm-100 tw-text-xs tw-leading-body tw-gap-x-2`}
  >
    <p className="[font:inherit]">
      <b>{text}</b>
    </p>
    {link?.link && link?.displayName && (
      <Anchor
        {...link}
        onClick={() =>
          promotionClicked({
            name: link.displayName,
            creative: `top_banner_${index}`,
            position: 'sitewide_banner',
            promotion_id: promotionId,
          })
        }
        className="!tw-underline hover:tw-text-brand-200"
      />
    )}
    {countdownClock && CountDownClock && <CountDownClock {...countdownClock} />}
  </li>
);

export default SitewidePromotion;
